import { useMutation } from "@apollo/client/react";
import { graphql, type ResultOf, type VariablesOf } from "@tucan/graphql";
import { COMPANY_SETTING_FRAGMENT } from "graphql/fragment/company.setting.fragment";

const MUTATION = graphql(`
  mutation update($input: CompanySettingInput!, $id: ID!) {
    setting: updateCompanySetting(setting: $input, id: $id) {
      ...CompanySetting
    }
  }
`, [COMPANY_SETTING_FRAGMENT]);

type Data = ResultOf<typeof MUTATION>;
type Variables = VariablesOf<typeof MUTATION>;

export const useUpdateCompanySettingMutation = (
  options: useMutation.Options<Data, Variables> = {},
): useMutation.ResultTuple<Data, Variables> => {
  const oldUpdate = options.update;
  options.update = (cache, result, options) => {
    cache.evict({
      fieldName: "getSettings",
    });
    cache.gc();

    if (oldUpdate) {
      oldUpdate(cache, result, options);
    }
  };

  return useMutation<Data, Variables>(MUTATION, options);
};
